// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7150":"32006cf2","8874":"5969218a"}[chunkId] + ".chunk.css";
};